import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getBalanceSheet = ({ churchId, startDate, endDate }) => {
  return axios.get(
    `/churches/${churchId}/balance-sheet?start_date=${startDate}&end_date=${endDate}`
  );
};

export const useBalanceSheet = ({
  churchId,
  startDate,
  endDate,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["balance-sheet", churchId, startDate, endDate],
    queryFn: () => getBalanceSheet({ churchId, startDate, endDate }),
    select: data => data.result
  });
};
